document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.tabs-nav .tab');
    const tabContents = document.querySelectorAll('.tabs-content .tab-content');
    
    // Fonction pour changer le contenu des onglets
    function switchTab(index) {
        // Masquer tous les contenus de tab
        tabContents.forEach(content => content.style.display = 'none');
        
        // Afficher le contenu de l'onglet sélectionné
        tabContents[index].style.display = 'flex';
        
        // Appeler la fonction pour centrer la carte sur le marqueur lié à cet onglet
        const mapId = 'gmap_block';  // Assurez-vous que l'ID de la carte soit correct
        window.initGoogleMap(mapId, index); // Appeler la fonction pour centrer la carte sur ce marqueur
    }

    // Ajout des événements de clic sur les onglets
    tabs.forEach((tab, index) => {
        tab.addEventListener('click', function () {
            switchTab(index);
        });
    });

    // Initialiser la première tab au chargement
    if (tabs.length > 0) {
        switchTab(0); // Afficher le premier onglet par défaut
    }
});
